import React from 'react';
import useDocumentTitle from '../useDocumentTitle'
import img_onshape from '../../img/onshape_logo.png'
import NavbarLearn from '../navbarLearn';
import Sidebar from '../learnSidebar';

export default function ThreeA() {
    useDocumentTitle("Chapter 3 Lesson A | 101Learn by the Spartabots")
    return (
        <div>
            <NavbarLearn />
            <div class="flex max-w-[100rem] mx-auto my-5 bg-gradient-to-r from-frcyellow to-frcpurple rounded-[2rem] items-center">
                <p class="font-scoutcond font-black italic text-white opacity-50 text-[30rem] ml-10 leading-none">03-A</p>
                <h class="z-20 absolute font-scoutcond font-black italic text-frcblue text-[10rem] ml-40 leading-none">WHAT IS ONSHAPE?</h>
                <p class="absolute ml-[9.4rem] mt-44 font-scoutcond font-black italic text-white text-[4rem] leading-none">LESSON 3-A</p>
            </div>
            <div class="flex flex-row max-w-[100rem] mx-auto mb-5">
                <div class="hidden md:flex basis-80 bg-gray-300 rounded-l-[2rem]">
                    <Sidebar />
                </div>
                <div class="basis-full h-full bg-gray-50 rounded-r-[2rem]">
                    <div class="mx-10 my-10">
                        <h class="font-scoutcond font-black italic text-[5rem] leading-none">LESSON OVERVIEW</h>
                        <p class="font-productsans font-bold text-3xl text-gray-400">Understand what Onshape is</p>
                        <p class="font-productsans text-base text-black mt-5">This lesson will cover the basics of what Onshape is, what it does, and what it's used for - to skip ahead, click on the chapter roadmap below:</p>
                        <a href="/learn/three">
                            <p class="font-avenir font-bold text-base text-frcblue mt-10 leading-none">CHAPTER 3</p>
                            <p class="font-scoutcond font-black text-[3rem] leading-none">INTRODUCTION TO ONSHAPE</p>
                        </a>
                        <div class="border-l-2 ml-5">
                            <ul class="font-productsans font-bold ml-3">
                                <li>
                                    <a class="transition-all ease-in-out text-frcpurple" href="/learn/three/a">What is Onshape?</a>
                                    <p class="font-productsans font-normal ml-3">Understand what Onshpae is and what it's used for.</p>
                                </li>
                                <li>
                                    <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/three/b">Setting up Onshape</a>
                                    <p class="font-productsans font-normal ml-3">Learn how to set up an Onshape account and get added to your team.</p>
                                </li>
                                <li>
                                    <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/three/c">Introduction to Sketching</a>
                                    <p class="font-productsans font-normal ml-3">Understand the concept of sketching within Onshape's Part Studio.</p>
                                </li>
                                <li>
                                    <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/three/d">Constraints</a>
                                    <p class="font-productsans font-normal ml-3">Learn how to constrain your sketches. Blue is bad.</p>
                                </li>
                                <li>
                                    <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/three/e">Introduction to Extrudes</a>
                                    <p class="font-productsans font-normal ml-3">Learn the basics of extruding a sketch into a 3D part.</p>
                                </li>
                                <li>
                                    <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/three/f">Introduction to the Assembly</a>
                                    <p class="font-productsans font-normal ml-3">Introduce yourself to Assembly. This might come as a surprise, but it's where you assemble stuff.</p>
                                </li>
                            </ul>
                        </div>
                        <h class="block font-scoutcond font-black italic text-[5rem] leading-none mt-20">WHAT IS ONSHAPE?</h>
                        <p class="font-productsans text-lg text-black">Onshape is a Computer Aided Design (CAD) software that engineers use to plan out their designs before moving on to manufacture them.
                            CAD designs have a variety of uses, including simulations, 3D-Printing, router manufacturing, and prototyping. In this section, we will dive into the basics of CAD and go over
                            key principles of design.
                        </p>
                        <img src={img_onshape} class="my-5 rounded-[1rem]" alt="The Onshape Logo"></img>
                        <p class="font-productsans text-lg text-black mt-5">Onshape itself is a intermediate-level platform with several key benefits:
                            <ul class="ml-5">
                                <li>
                                    <p>- Real time collaboration between different users on one part.</p>
                                </li>
                                <li>
                                    <p>- Online server platform, allowing documents to be shared and saved easily.</p>
                                </li>
                                <li>
                                    <p>- Intuitive and organized interface without too many cluttering features.</p>
                                </li>
                            </ul>
                            Onshape, along with many other CAD platforms, uses a sketch and extrude system, where you draw a 2D pattern and turn it into a 3D shape using a specific feature. If this doesn’t make sense yet don’t worry. This information will be more applicable later on when the features are explained individually.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}